import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminContacts from "@/pages/AdminContacts";
import AdminProjects from "@/pages/AdminProjects";
import AdminArticles from "@/pages/AdminArticles";
import AdminExperience from "@/pages/AdminExperience";
import AdminSettings from "@/pages/AdminSettings";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/contacts" element={<AdminContacts />} />
          <Route path="/admin/projects" element={<AdminProjects />} />
          <Route path="/admin/articles" element={<AdminArticles />} />
          <Route path="/admin/experience" element={<AdminExperience />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
